var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandLegacy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.687 23.687 11 28H0V17l4.212 4.212L9.425 16l2.474 2.475-5.214 5.212zm.05-19.424L11 0H0v11l4.263-4.263L9.425 11.9 11.9 9.424zm14.526 19.474L17 28h11V17l-4.263 4.263L18.475 16 16 18.475zm-.05-19.525L17 0h11v11l-4.313-4.313-5.212 5.212L16 9.423l5.212-5.213z"
  })));
};
export default SvgExpandLegacy;